import {
    TaxNoticeUploadRequest,
    CommentRequest
} from "@herbjoy/apex-api-models";

export function TaxNoticeService($http, apexApiUrl) {
    'ngInject'

    return {
        retrievedocuments: retrievedocuments,
        retrieveComments: retrieveComments,
        uploaddocument: uploaddocument,
        saveComment: saveComment,
        updateDescription: updateDescription,
        checkIfHJEE: checkIfHJEE,
        downloadDocument: downloadDocument,
        retrieveHJEEdocuments: retrieveHJEEdocuments,
        retrieveAssignedDocuments: retrieveAssignedDocuments,
        assignToTeamDocument: assignToTeamDocument,
        retrieveTeamDocuments: retrieveTeamDocuments,
        getUserRole: getUserRole,
        retrieveAssignedTeamDocuments: retrieveAssignedTeamDocuments,
        retrieveMyWorkDocuments: retrieveMyWorkDocuments,
        retrieveCompletedDocuments: retrieveCompletedDocuments,
        assignToTeamMember: assignToTeamMember,
        assignToMe: assignToMe,
        unAssignDocument: unAssignDocument,
        unAssignDocumentFromEmployee: unAssignDocumentFromEmployee,
        retrievePendingDocuments: retrievePendingDocuments,
        SendForApproval: sendForApproval,
        completeDocument: completeDocument,
        declineDocument: declineDocument,
        retrieveStatusHistory: retrieveStatusHistory,
        downloadNoticeCommentDocument: downloadNoticeCommentDocument
    };

    /**
     * Retrieve the tax document with the given userEmail.
     * @param {any} userName The emailId of user .
     * @returns {Promise<any>} The resolved tax notice.
     */
    function retrievedocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveHJEEdocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/retrieveHJEEdocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveTeamDocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/retrieveTeamDocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveAssignedTeamDocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/retrieveAssignedTeamDocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrievePendingDocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/RetrievePendingDocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveMyWorkDocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/RetrieveMyWorkDocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveCompletedDocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/RetrieveCompletedDocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveAssignedDocuments(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/retrieveAssignedDocuments/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function checkIfHJEE(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/CheckIfHJEE/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function getUserRole(userName) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/GetUserRole/" + userName,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function retrieveComments(noticeDocumentId) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/GetComments/" + noticeDocumentId,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            });
    }

    function retrieveStatusHistory(requestId) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/StatusHistory/" + requestId,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            });
    }

    function completeDocument(noticeDocumentId) {
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/completeDocument/" + noticeDocumentId,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function declineDocument(noticeDocumentId: any) {
        console.log(noticeDocumentId);
        return $http({
            method: "GET",
            url: apexApiUrl + "taxNotice/declineDocument/" + noticeDocumentId,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    function uploaddocument(userName, data: TaxNoticeUploadRequest) {
        const formData = createTaxNoticeUploadRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/UploadDocument/" + userName,
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function downloadDocument(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/DownloadDocument",
            data: formData,
            responseType: 'arraybuffer',
            headers: { "Content-Type": undefined }
        })
            .then(function (result, status, headers, config) {
                const filesBytes = result.data;
                const fileName = result.headers('Content-Disposition').split(';')[1].trim().split('filename=')[1].replaceAll('"', '')
                const blob = new Blob([filesBytes], { type: result.headers("Content-Type") });
                const objectUrl: string = URL.createObjectURL(blob);
                const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
                a.href = objectUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(objectUrl);
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function downloadNoticeCommentDocument(data: CommentRequest) {
        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/DownloadCommentDocument",
            data: formData,
            responseType: 'arraybuffer',
            headers: { "Content-Type": undefined }
        })
            .then(function (result, status, headers, config) {
                const filesBytes = result.data;
                const fileName = result.headers('Content-Disposition').split(';')[1].trim().split('filename=')[1].replaceAll('"', '')
                const blob = new Blob([filesBytes], { type: result.headers("Content-Type") });
                const objectUrl: string = URL.createObjectURL(blob);
                const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
                a.href = objectUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(objectUrl);
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function sendForApproval(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/SendForApproval",
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function assignToTeamDocument(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/AssignToTeamDocument",
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }


    function unAssignDocument(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/UnassignDocument",
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function unAssignDocumentFromEmployee(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/UnassignDocumentFromEmployee",
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function assignToMe(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/AssignToMe",
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });

    }

    function assignToTeamMember(data: CommentRequest) {

        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + "taxNotice/AssignToTeamMember",
            data: formData,
            headers: { "Content-Type": undefined }
        })
            .then(function (response) {
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function saveComment(data: CommentRequest) {
        console.log(data);
        const formData = createRequestFormData(data);
        return $http({
            method: "POST",
            url: apexApiUrl + 'taxNotice/saveComment',
            data: formData,
            headers: { "Content-Type": undefined, Accept: "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }

    function updateDescription(data: CommentRequest) {
        return $http({
            method: "POST",
            url: apexApiUrl + 'taxNotice/UpdateDescription',
            data: data,
            headers: { Accept: "application/json", "Content-Type": "application/json" }
        })
            .then(function (response) {
                // settaxNoticeReferences(response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err)
            });
    }
}

function createTaxNoticeUploadRequestFormData(request): FormData {
    const formData = new FormData();
    formData.append("Description", request.Description);
    formData.append("IcdCorporationId", request.IcdCorporationId);

    for (let i = 0; i < request.Files.length; i++) {
        formData.append('Files[' + i + ']', request.Files[i]);
    }
    return formData;
}

function createRequestFormData(request): FormData {
    const formData = new FormData();

    formData.append("TaxNoticeDocumentId", request.TaxNoticeDocumentId);
    formData.append("CommentId", request.CommentId);
    formData.append("UserName", request.UserName);
    formData.append("Text", request.Text);
    formData.append("TeamId", request.TeamId);
    formData.append("TeamMemberEmpId", request.TeamMemberEmpId);
    if (request.Files !== undefined) {
        if (request.Files.length !== undefined) {
            for (let i = 0; i < request.Files.length; i++) {
                formData.append('Files[' + i + ']', request.Files[i]);
            }
        }
        formData.append('Files[0]', request.Files);
    }
    return formData;
}
